import { render } from "./NoMaterialsRequired.vue?vue&type=template&id=6ca59656&scoped=true"
import script from "./NoMaterialsRequired.vue?vue&type=script&lang=js"
export * from "./NoMaterialsRequired.vue?vue&type=script&lang=js"

import "./NoMaterialsRequired.vue?vue&type=style&index=0&id=6ca59656&scoped=true&lang=css"

import exportComponent from "C:\\Users\\s574086\\textbook-ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ca59656"]])

export default __exports__